// Several loads can be in flight at once (the 30-second refresh, a reload after an action, a tab coming
// back). Each load notes which resources it asked for; when its answers arrive, an answer is used only if
// no newer load has asked for that same resource since. A late, stale answer therefore cannot replace
// fresher data, while the resources that no newer load touched are still filled in.
export function claimKeys(latest, keys, version) {
  keys.forEach((key) => { latest[key] = version; });
}

export function isLatest(latest, key, version) {
  return latest[key] === version;
}

// The 30-second refresh is for a person looking at the screen; a hidden tab skips it.
export function pollIfVisible(load, keys, doc = document) {
  if (doc.visibilityState === "hidden") return false;
  load(keys);
  return true;
}
